export default __webpack_public_path__ + "static/media/urban-legend.af6cf021.png";